import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '@app/shared/auth/auth.service';
import { DEVICE_ID_KEY, PHYSICAL_DEVICE_ID_KEY, DEVICE_STATUS_KEY } from '@app/shared/constants/settings.constants';
import { CacheService } from '@app/shared/services/helpers/cache.service';
import { DeviceFingerprintService } from '@app/shared/services/helpers/device-fingerprint.service';
import { environment } from '@env/environment';
import { NgxMasonryOptions } from 'ngx-masonry';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SurveyComponent } from '@app/shared/components/survey/survey.component';
import { SettingsService } from '@app/shared/services/api/settings.service';
import { SurveyService } from '@app/shared/services/api/survey.service';
import { SplitService } from '@app/shared/services/helpers/split.service';
import { TourserviceService } from '@app/shared/services/helpers/tourservice.service';
import Swal from 'sweetalert2';
import { SurveyFeedbackModalComponent } from '@app/shared/components/survey-feedback-modal/survey-feedback-modal.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('f', { static: true }) loginForm: NgForm;

  alert: any = {};

  masonryOptions: NgxMasonryOptions = {
    itemSelector: '.masonry-item',
    columnWidth: 200,
    fitWidth: true
  };
  masonryItems: any = [];

  submitted: boolean = false;

  email: string;
  password: string;
  privacy: boolean;
  surveyFeature: boolean = false;
  today: Date = new Date();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService,
    private http: HttpClient,
    private cacheService: CacheService,
    private deviceFingerprint: DeviceFingerprintService,
    private modalService: NgbModal,
    private setSvc: SettingsService,
    private surveyService: SurveyService,
    private splitService: SplitService,
    private tourService: TourserviceService
  ) {}

  ngOnInit() {
    this.closeAlert();
    this.http.get(`/assets/json/loginshop.json`).subscribe((resp) => {
      this.masonryItems = resp;
    });
    this.cacheService.clearCache();
  }

  closeAlert() {
    this.alert = {};
  }

  async onSubmit() {
    if (!this.email || !this.password) {
      this.alert = { error: 'Invalid login' };
      return;
    }
    if (!this.privacy) {
      this.alert = { error: 'Please read and accept the MyMedsPH Privacy Policy.' };
      return;
    }

    this.submitted = true;

    // Get comprehensive device fingerprint (visitorId + hardwareData + hardwareFingerprint)
    // This ensures persistence even when visitorId changes after cache clear
    const deviceFingerprint = await this.deviceFingerprint.getDeviceFingerprint();

    // Use visitorId as deviceId, prefer new visitorId over old localStorage value
    // This ensures we always use the latest visitorId from FingerprintJS
    const deviceId = deviceFingerprint.visitorId || localStorage.getItem(DEVICE_ID_KEY);

    const formData = this.loginForm.value;
    formData.deviceId = deviceId;

    this.auth.login(formData).subscribe(
      (data) => {
        this.auth.authenticationState.next(true);
        this.auth.getLoginProfile(true);
        this.cacheService.cacheData();

        // Store deviceId in localStorage after successful login
        localStorage.setItem(DEVICE_ID_KEY, data['deviceId']);
        localStorage.setItem(DEVICE_STATUS_KEY, data['isDeviceAuthorized']);

        if (this.auth.isAdmin()) {
          this.setSvc.getSettings().subscribe(() => {
            const tourActive = this.tourService.isAdminVirtualTourActive();
            const targetRoute = tourActive
              ? this.tourService.getResumeRoute()
              : '/manage/settings/my-account';

            this.router.navigateByUrl(targetRoute).then(() => {
              if (!tourActive) {
                this.checkSurveyStatus();
              }
            });
          });
        } else {
          this.router.navigate(['landing']);
          this.router.navigate(['landing']).then(() => {
            this.checkSurveyStatus();
          });
        }
        this.submitted = false;
      },
      (error) => {
        this.submitted = false;
        this.alert = error.error;
      }
    );
  }

  onForgotPassword() {
    this.router.navigate(['forgotpassword'], { relativeTo: this.route.parent });
  }

  signup() {
    this.router.navigate(['signup'], { relativeTo: this.route.parent });
  }
  sendOTP() {
    // create send otp
  }
  checkSurveyStatus() {
    this.splitService.getTreatment('survey_questionnaire')
    .then(treatment => {
        this.surveyFeature = treatment === 'on';
        if(this.surveyFeature){
          this.surveyService.getStatus().subscribe(data => {
            if (data.submitted == false) {
              this.openSurveyModal();
            }
          });
        }
    });
   }

  openSurveyModal() {
    const modalRef = this.modalService.open(SurveyFeedbackModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      centered: true,
      windowClass: 'survey-feedback-modal-window'
    });

    modalRef.componentInstance.startSurvey.subscribe(() => {
      // Close the feedback modal and open the actual survey
      modalRef.close();
      this.modalService.open(SurveyComponent, {
        size: 'xl',
        backdrop: 'static',
        centered: true,
        keyboard: false,
        windowClass: 'mmp-survey-modal-window'
      });
    });

    modalRef.result.then((result) => {
      if (result === 'start') {
        // Survey will be opened by the event listener above
      }
    }, (reason) => {
      // Modal was dismissed
    });
  }
}
